import { useAppDispatch, useAppSelector } from '@/Application/Hooks/Redux';
import { Tooltip } from '@/modules/perseo-billing/components';
import { TPaymentMethodId } from '@/modules/perseo-billing/components/accordion/interfaces';
import { useAccordion } from '@/modules/perseo-billing/components/accordion/use-accordion';
import { useEnableAccordion } from '@/modules/perseo-billing/components/accordion/use-enable-accordion';
import { ClubType } from '@/modules/perseo-billing/interfaces/src/bff-web/billing';
import { setActiveAccordion } from '@/modules/perseo-billing/store/slices/billing';
import {
  Icon,
  Typography
} from '@/modules/perseo-billing/ui/react/src/components/beta';
import { useMediaQuery } from '@/modules/perseo-billing/ui/react/src/ui-hooks';

import { AccordionTemplate } from '../../../payment-methods/components/payment-method/accordion-template.component';
import PaymentMethodTitle from '../../../payment-methods/components/title/payment-method-title';

import { AppliedCode } from './applied-club-code.component';
import { FormAddClubCode } from './form-add-club-code.component';

import 'react-popper-tooltip/dist/styles.css';

export const ClubParis = () => {
  const dispatch = useAppDispatch();

  const { getPaymentMethodEnabled } = useEnableAccordion();

  const { getActiveItem } = useAccordion();
  const isEnabled = getPaymentMethodEnabled(TPaymentMethodId.CLUB);

  const accordionIndexes = {
    accordionIndex: 3,
    itemIndex: 0
  };

  const isActive = getActiveItem(accordionIndexes);

  const newActiveAccordion = { activeAccordionIndex: 3, activeItemIndex: 0 };

  const toggleCollapse = () => {
    dispatch(setActiveAccordion(isActive ? null : newActiveAccordion));
  };

  const accordionProps = {
    isEnabled,
    isActive
  };

  return (
    <>
      <PaymentMethodTitle title={'Programa Club Paris'} />

      <AccordionTemplate
        {...accordionProps}
        header={<ClubHeader {...accordionProps} handleClick={toggleCollapse} />}
        body={<ClubBody />}
      />
    </>
  );
};

type PropsClubHeader = {
  isActive: boolean;
  handleClick: () => void;
  isEnabled: boolean;
};

export const ClubHeader = (props: PropsClubHeader): JSX.Element => {
  const isMobile = useMediaQuery('lg');

  const { isActive, isEnabled, handleClick } = props;
  const disableSubtitleMessage = !isEnabled ? 'No disponible con factura' : '';

  const headerTitle = '¿Tienes puntos Novios o Bebé?';
  const tooltipTitle = '¿Qué es Club Paris?';
  const tooltipDescription =
    'Son clubes de beneficios para acompañarte en momentos especiales. Conócelos en la sección Mundo Paris de nuestra web.';

  return (
    <button
      className="co-w-full co-flex co-gap-8px co-p-16px lg:co-px-24px lg:co-py-8px co-justify-between co-items-center"
      onClick={handleClick}
    >
      <div className="co-w-full co-flex co-gap-16px co-items-center">
        <div
          style={{ filter: !isEnabled ? 'grayscale(1)' : 'none' }}
          className="co-w-40px co-h-40px co-flex co-items-center co-justify-center co-p-4px co-rounded-full"
        >
          <Icon icon={'PlateWithPercent'} height={24} width={24} />
        </div>
        <div className="co-flex co-gap-4px co-items-center">
          <div>
            <Typography
              weight="semibold"
              size={isMobile ? 'body1' : 'h4'}
              color={!isEnabled ? 'gray' : 'default'}
              noWrap
            >
              {headerTitle}
            </Typography>
            {disableSubtitleMessage && (
              <Typography color="pds-neutral-700">
                {disableSubtitleMessage}
              </Typography>
            )}
          </div>
          {!isMobile && (
            <Tooltip title={tooltipTitle} description={tooltipDescription} />
          )}
        </div>
      </div>
      <Icon
        color="black"
        height={24}
        width={24}
        icon={isActive ? 'NewArrowDownIcon' : 'NewArrowUpIcon'}
      />
    </button>
  );
};

export const ClubBody = () => {
  const { data } = useAppSelector((state) => state.cart);
  const {
    clubParisCode,
    clubParisCodeType,
    weddingFirstName1: firstName,
    weddingFirstName2: secondName
  } = data || {};

  return clubParisCode ? (
    <AppliedCode
      clubParis={clubParisCode || ''}
      clubParisCodeType={clubParisCodeType!}
      firstName={firstName || ''}
      secondName={clubParisCodeType !== ClubType.BABY ? secondName : ''}
      babyName={clubParisCodeType === ClubType.BABY ? secondName : ''}
    />
  ) : (
    <FormAddClubCode />
  );
};
